<template>
  <h1>Manage Brands</h1>
  <div id="page-assemble" class="content-section">
    <div class="page-section">
      <h2>Brands List
        <a @click="addItem()" class="float-right btn btn-primary btn-sm">Add new</a>
      </h2>
      <div class="row">
        <div class="col-md-8">
          <span>Find brand: </span>
          <input type="text" v-model="searchValue">
          <easy-data-table
              :loading="loading"
              :headers="headers"
              :items="brandsList"
              :search-field="searchField"
              :search-value="searchValue"
              alternating
              border-cell
              buttons-pagination
          >
            <template #empty-message>
              nothing here for the moment
            </template>

            <template #loading>
              <font-awesome-icon
                  icon="spinner"
                  size="2x"
                  title="Loading"
                  spin
              >
              </font-awesome-icon>
            </template>

            <template #item-logopath="{ logopath, logopath_publicURL }">
              <div class="player-wrapper">
                <img v-if="logopath" width="20" :src="logopath_publicURL"/> <small>{{ logopath }}</small>
              </div>
            </template>

            <template #item-operation="item">
              <div class="operation-wrapper">
                <font-awesome-icon
                    icon="edit"
                    size="1x"
                    class="operation-icon"
                    title="Edit"
                    @click="editItem(item)">
                </font-awesome-icon>
                <font-awesome-icon
                    icon="trash"
                    size="1x"
                    class="operation-icon delete"
                    title="Delete"
                    @click="deleteItem(item)">
                </font-awesome-icon>

              </div>
            </template>
          </easy-data-table>
        </div>
        <div class="edit-item col-md-4" v-if="isEditing || isAdding">
          <FormKit
              v-if="!submitted && !errorMessage"
              type="form"
              v-model="editingItem"
              @submit="saveBrand"
              :actions="false"
              :config="{
                validationVisibility: 'dirty',
              }"
              form-class="bordered"
              id="formColour"
          >
            <!--<h4 class="text-blue-bold text-left" v-if="isEditing">{{ editingItem.brandname }}</h4>-->

            <h4 class="text-blue-bold text-left" v-if="isAdding">Add new</h4>
            <div class="formkit-wrapper mb-3"  >
              <FormKit
                  v-model="editingItem.brandname"
                  type="text"
                  name="brandname"
                  id="brandname"
                  label="Brand name"
                  help="Brandname, must be unique"
                  placeholder="brand name"
                  validation="required"
              />
              <!--<FormKit
                  v-model="editingItemBrandId"
                  name="brand_id"
                  type="autocomplete"
                  label="Brand"
                  label-class="text-left"
                  source-label="All brands"
                  source-empty-message="No brand found"
                  :options="searchBrands"
                  searchable
                  placeholder="Search brands"
                  required
              />-->
            </div>
            <img v-if="editingItem.logopath" width="30" :src="editingItem.logopath_publicURL"/>
            <FormKit
                id="logo_file"
                type="file"
                label="Logo"
                name="editing_logo"
                accept=".jpg,.png"
                help="Accepted files: .jpg,.png"
                label-class="text-left"
                @change="appendFile($event.target.name, $event.target.files)"
                clearable="true"
            />
            <FormKit
                id="highvalue"
                v-model="editingItem.highvalue"
                type="toggle"
                on-value-label="Yes"
                off-value-label="No"
                on-value="1"
                off-value="0"
                name="highvalue"
                label="Is Brand high value?"
            />

            <FormKit
                id="highrisk"
                v-model="editingItem.highrisk"
                type="toggle"
                on-value-label="Yes"
                off-value-label="No"
                on-value="1"
                off-value="0"
                name="highrisk"
                label="Is Brand high risk?"
            />

            <FormKit
                v-if="isEditing"
                name="brand_id"
                type="hidden"
                value="{{ editingItem.brand_id }}"
            />

            <FormKit
                type="submit"
                label="Save"
                outer-class="half"
                input-class="$reset btn btn-primary"
            />

            <FormKit
                type="button"
                label="Cancel"
                outer-class="half"
                input-class="$reset btn btn-secondary btn-sm"
                @click="resetBrands"
            />
          </FormKit>
          <div v-if="submitted">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-success">{{successMessage}}</div>
          </div>
          <div v-if="errorMessage">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-danger">{{errorMessage}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>

import {onMounted, ref, inject, reactive} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';

import BrandDataService from "@/services/BrandDataService";

//const formData = ref({})
const isEditing = ref(false);
const isAdding = ref(false);
const submitted = ref(false);
const errorMessage = ref(false);
const successMessage = ref(false);
const loading = ref(true);
const brandsList =  ref([]);
const editingItem = ref({
  brandname: "",
  logopath: "",
  logopath_publicURL: "",
  highvalue: "",
  highrisk: "",
  brand_id: 0,
});
const currentBrand = ref('');
const currentIndex = ref('');
const editingItemBrandId = ref('');
const searchField = ref(["brandname", "brand_id"]);
const searchValue = ref("");

const headers =[
  { text: "ID", value: "brand_id", sortable: true  },
  { text: "Name", value: "brandname", sortable: true  },
  { text: "Logo", value: "logopath" },
  { text: "High Value", value: "highvalue", sortable: true },
  { text: "High Risk", value: "highrisk", sortable: true },
  { text: "Actions", value: "operation"},
];

const formState = reactive({
  file: null,
  filename: null
});

const appendFile = (name, files) => {
  formState.filename = name;
  formState.file = files[0];
}
/**
 * Populate the form details for brand
 */
const editItem = async (Item) => {

  isEditing.value = true;
  isAdding.value = false;
  emptyBrandForm();
  editingItem.value.brandname = Item.brandname;
  editingItem.value.logopath = Item.logopath;
  editingItem.value.logopath_publicURL = Item.logopath_publicURL;
  editingItem.value.highvalue = "" + Item.highvalue;
  editingItem.value.highrisk = "" + Item.highrisk;
  editingItem.value.brand_id = Item.brand_id;
  console.log("Item.highvalue", Item.highvalue);
  console.log("Item.highrisk", Item.highrisk);
}
const deleteItem = async (Item) => {
  if(confirm("Do you really want to delete?")) {
    BrandDataService.delete(Item.brand_id)
        .then(response => {
          if (response.data.status == "OK") {
            isEditing.value = true;
            submitted.value = true;
            successMessage.value = 'Item successful deleted!';
            setTimeout(() => {
              isAdding.value = false;
              isEditing.value = false;
              refreshList();
            }, 3000)

          } else {
            errorMessage.value = response.data.message;
          }
         // console.log(response);
        })
        .catch(e => {
          console.log(e);
          errorMessage.value = e;
        });
  }
}
/**
 * Updates a brand details
 * @returns {Promise<void>}
 */
const saveBrand = async () => {
  let updateObj;

  if (editingItem.value.brand_id == 0)
  {
    editingItem.value.brand_id = editingItemBrandId;
  }
  updateObj = {
    brandname: editingItem.value.brandname,
    logopath: editingItem.value.logopath,
    logopath_publicURL: editingItem.value.logopath_publicURL,
    highvalue: editingItem.value.highvalue,
    highrisk: editingItem.value.highrisk,
    brand_id: editingItem.value.brand_id
  }


  let formData = new FormData();
  formData.append('file', formState.file);
  Object.keys(updateObj).forEach((key) => {
    formData.append(`${key}`, `${updateObj[key]}`);
  });
  BrandDataService.save(formData)
      .then(response => {
        if (response.data.status == "OK"){
          submitted.value=true;
          successMessage.value = 'Submission successful!';
          setTimeout(() => {
            isAdding.value = false;
            isEditing.value = false;
            refreshList();
          }, 3000)
        } else if (response.data.status == "DUPLICATE") {
          isAdding.value = true;
          submitted.value = false;
          successMessage.value = '';
          errorMessage.value=response.data.message;

        } else {
          if (response.data.message != "") {
            isAdding.value = true;
            isEditing.value = false;
            errorMessage.value=response.data.status + ": " + response.data.message;
            console.log('open div');
            return false;
          } else {
            errorMessage.value=response.data.status + " Please contact the administrator.";
            setTimeout(() => {
              isAdding.value = false;
              isEditing.value = false;
              errorMessage.value = false;
              resetBrands();
            }, 3000)
          }


        }
        //console.log(response);
      })
      .catch(e => {
        console.log(e);
        errorMessage.value=e;
        setTimeout(() => {
          isAdding.value = false;
          isEditing.value = false;
          errorMessage.value = false;
          resetBrands();
        }, 3000)
      });
}
/*
const preventSubmit = (e) => {
  e.preventDefault();
  return false;
}*/

/**
 * Perform an API request to find brands based on keyword used on autocomplete
 * @param search
 * @returns {Promise<{label: string, value: *}[]|*[]>}
 */
const searchBrands = async ({search}) => {
  try {
    const response = await BrandDataService.findByBrand(search);
    const res = response.data.data.brands;

    // Map the data and return it
    return res.map((entry) => ({
      label: entry.text,
      value: entry.id,
    }));
  } catch (e) {
    console.log(e);
    return [];
  }
}
const emptyBrandForm = async () => {
  editingItem.value.brandname = '';
  editingItem.value.logopath = '';
  editingItem.value.logopath_publicURL = '';
  editingItem.value.highvalue = '';
  editingItem.value.highrisk = '';
  editingItem.value.brand_id = '';
  successMessage.value = '';
  errorMessage.value = '';
  editingItem.value.file = '';
  //document.getElementById('editing_logo')[0].file = null
  //document.getElementById('editing_logo').value= '';
  //document.getElementById('formColour').reset();

}
const resetBrands = async () =>  {
  emptyBrandForm();

  isAdding.value = false;
  isEditing.value = false;
}
const refreshList = async () =>  {
  retrieveBrandList();
  currentBrand.value = null;
  currentIndex.value = -1;
}
function retrieveBrandList() {
  submitted.value = false;
  errorMessage.value = false;
  BrandDataService.getAll()
      .then(response => {
       // console.log(response.data.data);
        brandsList.value = response.data.data.brands;
        //convert object to array
        // this.brandsList = Object.entries(response.data.brands);
        //console.log(response.data.data.brands);
        loading.value = false;
      })
      .catch(e => {
        console.log(e);
      });
}


function addItem() {
  isAdding.value = true;
  isEditing.value = false;
  emptyBrandForm();
}
onMounted(() => {
  retrieveBrandList();
})
</script>


<style scoped>

.half {
  float: left;
  width: 50%;
}
.formkit-option {
  display: flex;
  align-items: center;
}
.color-options {
  width: 30px;
  height: 30px;
}
[data-invalid] .formkit-inner {
  border-color: var(--red-color);
  box-shadow: 0 0 0 1px var(--red-color);
}

[data-complete] .formkit-inner {
  border-color: var(--red-color);
  box-shadow: 0 0 0 1px var(--green-color);
}
[data-complete] .formkit-inner::after {
  content: '✅';
  display: block;
  padding: 0.5em;
}
.formkit-form.bordered {
  padding: 0.5rem 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border: 1px solid var(--form-border-color);
  box-shadow: 0 2px 3px var(--form-shadow-color);
  display: block;
  float: left;
  width: 100%;
}
.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: .875rem;
}
</style>
